import { Banner, Text } from '@betterment/samba-react';

export function MissingPreviewDataBanner() {
  return (
    <Banner variant="warning" css={{ width: '100%' }}>
      <Text>
        Some data couldn’t be retrieved due to pending actions, account restrictions, or temporary system issues.
        Refresh the page or try again later.
      </Text>
    </Banner>
  );
}
